module.exports = __webpack_public_path__ + "media/lacto-large.822cfb57.mp4";